import { Swipe } from 'Lib/swipe/swipe';

const elSlidesCont = document.querySelector('.book-page__cover-slides-cont');
const swipe = new Swipe(elSlidesCont, 70);
const left = () => {
    const elsRadio = document.querySelectorAll('.book-page__cover-radio');
    const elRadioCheck = document.querySelector('.book-page__cover-radio:checked');

    if (elRadioCheck && Number(elRadioCheck.value) !== elsRadio.length) {
        elRadioCheck.checked = false;
        elRadioCheck.nextElementSibling.checked = true;
    }
};
const right = () => {
    const elRadioCheck = document.querySelector('.book-page__cover-radio:checked');

    if (elRadioCheck && Number(elRadioCheck.value) !== 1) {
        elRadioCheck.checked = false;
        elRadioCheck.previousElementSibling.checked = true;
    }
};

swipe.onLeft = left;
swipe.onRight = right;